/* =========================================
   Scroll-triggered Animations
   IntersectionObserver-based reveal
   ========================================= */

(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px',
    }
  );

  function observe() {
    document.querySelectorAll('[data-animate]:not(.is-visible)').forEach((el) => {
      observer.observe(el);
    });
  }

  // Initial observe
  observe();

  // Re-observe on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', observe);
})();
